module.exports = __webpack_public_path__ + "static/blog52-c76141a82386f51fe7b1b4538c6e5105.png";